import {Map} from 'immutable';

export function splitIconSets(iconSets, icons, iconSetIdsInSubscription, workingSetIcons) {
  const iconSetsById = Map(iconSets
    .map((iconSet) => {
      return [iconSet.id, iconSet];
    })
  );
  const systemIconSets = iconSets.filterNot((iconSet) => {
    return iconSet.custom;
  });
  const iconSetsByIconId = Map(icons.map((icon) => {
    return [icon.id, iconSetsById.get(icon.iconSet)];
  }));
  const iconSetsUsed = workingSetIcons.map((workingSetIcon) => {
    return iconSetsByIconId.get(workingSetIcon.icon);
  });
  const available = systemIconSets.filter((iconSet) => {
    return iconSetIdsInSubscription.includes(iconSet.id);
  });
  const availableUsed = available.filter((iconSet) => {
    return iconSetsUsed.includes(iconSet);
  });
  const availableNotUsed = available.filter((iconSet) => {
    return !availableUsed.includes(iconSet);
  });
  const unavailable = systemIconSets.filter((iconSet) => {
    return !available.includes(iconSet);
  });

  return {available, availableUsed, availableNotUsed, unavailable};
}

export function sortTypefaces(typefaces) {
  const desiredStyleOrder = ['normal', 'italic'];

  return typefaces.sort((valueA, valueB) => {
    const aStyleOrder = desiredStyleOrder.indexOf(valueA.style);
    const bStyleOrder = desiredStyleOrder.indexOf(valueB.style);

    if (valueA.family < valueB.family) {
      return -1;
    } else if (valueA.family > valueB.family) {
      return 1;
    }

    if (aStyleOrder < bStyleOrder) {
      return -1;
    } else if (aStyleOrder > bStyleOrder) {
      return 1;
    }

    if (valueA.weight < valueB.weight) {
      return -1;
    } else if (valueA.weight > valueB.weight) {
      return 1;
    }

    return 0;
  });
}



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/utils/records.js